<template>
  <div v-bind:style="homeAccebility(isAccebility)">
    <section>
      <Navbars />
    </section>
    <section class="contents">
      <router-view />
    </section>
    <section>
      <Footers />
    </section>
    <!-- <img src="../assets/logo/500-jakarta.png" class="img-float-right"> -->
    <div class="container-float" v-if="isDisplayfloat">
      <div class="item-float">
        <a target="_blank" href="https://jakarta500.id"
          ><img src="../assets/logo/500-jakarta.png"
        /></a>
        <i
          class="fa fa-times"
          aria-hidden="true"
          @click="isDisplayfloat = false"
        ></i>
      </div>
      <div class="circle-float" style="animation-delay: 0s"></div>
      <div class="circle-float" style="animation-delay: 0.2s"></div>
      <div class="circle-float" style="animation-delay: 0.8s"></div>
    </div>
  </div>
</template>

<script>
import Navbars from "../components/Navbars.vue";
import Footers from "../components/Footers.vue";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default {
  name: "MainHome",
  components: {
    Navbars,
    Footers,
  },
  data() {
    return {
      isAccebility: this.$store.state.isAccebility,
      isDisplayfloat: true,
      popupImagePath: "",
      popupLink: "",      
      baseUrl: this.$store.state.baseUrl,
      baseApi: this.$store.state.apiUrl,
    };
  },

  computed: {
    isPopupLinkValid() {
      return this.popupLink && this.isValidURL(this.popupLink);
    },
  },

  mounted() {
    
  },

  methods: {
    homeAccebility(isAccebility) {
      if (isAccebility.modeMalam) {
        return {
          backgroundColor: "black",
        };
      } else {
        return {
          backgroundColor: "white",
        };
      }
    },
    
  },
};
</script>